module.exports = __webpack_public_path__ + "static/media/DottedMap.210fb4fe.svg";